// extracted by mini-css-extract-plugin
module.exports = {"card":"EmptyCard_card__k_5W8","icon":"EmptyCard_icon__m0Yvy"};